import { gql } from 'graphql-request';
import {
  MaterialBlocked,
  MaterialBrandID,
  MaterialBrandLocalizedName,
  MaterialBrandName,
  MaterialBrandUUID,
  MaterialCategoryID,
  MaterialCategoryName,
  MaterialCreatedAt,
  MaterialFavorite,
  MaterialID,
  MaterialImageFile,
  MaterialImageID,
  MaterialImageUUID,
  MaterialMaxFileCreatedAt,
  MaterialName,
  MaterialNanoID,
  MaterialNda,
  MaterialUUID
} from '../materialsTypes';

export interface FetchMaterialsQueryResponse {
  blocked: MaterialBlocked;
  favorite: MaterialFavorite;
  id: MaterialID;
  uuid: MaterialUUID;
  nanoId: MaterialNanoID;
  name: MaterialName;
  nda: MaterialNda;
  sku: MaterialUUID;
  createdAt: MaterialCreatedAt;
  updatedAt: MaterialCreatedAt;
  image: {
    id: MaterialImageID;
    uuid: MaterialImageUUID;
    file: MaterialImageFile;
  };
  brand: {
    id: MaterialBrandID;
    uuid: MaterialBrandUUID;
    name: MaterialBrandName;
    localizedName: MaterialBrandLocalizedName;
  };
  categories?: {
    id: MaterialCategoryID;
    localizedName: MaterialCategoryName;
  }[];
  maxFile: {
    createdAt: MaterialMaxFileCreatedAt;
  };
}

export const FETCH_MATERIALS_QUERY = gql`
  query Materials(
    $filters: MaterialsFilters
    $sort: [MaterialsSortEnum!]
    $limit: Int
    $offset: Int
  ) {
    materials(filters: $filters, sort: $sort, limit: $limit, offset: $offset) {
      nodes {
        blocked
        favorite
        id
        uuid
        nanoId
        name
        nda
        sku
        createdAt
        updatedAt
        image {
          id
          uuid
          file
        }
        brand {
          id
          uuid
          name
          localizedName
        }
        categories {
          id
          localizedName
        }
        maxFile {
          createdAt
        }
      }
      paginationInfo {
        currentPage
        nextPage
        totalCount
      }
      sql
    }
  }
`;
